"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = exports.default = debounce;
var _react = require("react");
// nui-widgets-v27: rename useDebounce and remove eslint-disable
function debounce(func, delay = 150) {
  let timeout;
  const cleanup = () => {
    clearTimeout(timeout);
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  (0, _react.useEffect)(() => cleanup, []);
  function debounced(...args) {
    const later = () => {
      // @ts-expect-error this
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
  }
  debounced.clear = cleanup;
  return debounced;
}